import { useState , useEffect } from 'react';
import Search from '../components/Dashboard/Search.js';
import './../styles/Dashboard.css';
import config from '../constants/config.js';
import GemstonesTable from '../components/Dashboard/GemstonesTable.js';
import GemstoneEditorModal from '../components/Dashboard/GemstoneEditorModal.js';
import GemstoneLinkerModal from '../components/Dashboard/GemstoneLinkerModal.js';

function Gemstones() {
    const [ showModal, setShowModal ] = useState( false );
    const [ showProductLinksModal, setShowProductLinksModal ] = useState( false );
    const [ gemstoneToEdit, setGemstoneToEdit ] = useState( null );
    const [ gemstones , setGemstones ] = useState( [] );
    const [ gemstoneVariantLinks , setGemstoneVariantLinks ] = useState( {} );
    const [ loadingTable , setLoadingTable ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ reloadTable , setReloadTable ] = useState( 0 );

    function openModal( gemstone = null ) {
        setGemstoneToEdit( gemstone );
        setShowModal( true );
    }

    function openLinkerModal() {
        setShowProductLinksModal( true );
    }

    useEffect( () => {
        async function load() {
            setLoadingTable( true );

            /**
             * Load Gemstones. 
             */
            const _gemstones = await getGemstones( currentPage );
            if ( _gemstones != null ) {
                setTotalPages( _gemstones?.pagination?.total_pages || 0 );
                setGemstones( _gemstones?.gemstones || [] );
            }
            
            /**
             * Load Gemstone Variant Links 
             */
            const _gemstoneVariantLinks = await getGemstoneVariantLinks();
            if ( _gemstoneVariantLinks.length > 0 ) {
                setGemstoneVariantLinks( _gemstoneVariantLinks )
            }

            setLoadingTable( false );
        }

        load();
    } , [ currentPage , reloadTable ] );

    async function getGemstones( page ) {
        let gemstoneData = null;

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/gemstones?page=${encodeURIComponent( page )}&limit=${encodeURIComponent(25)}`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.gemstones?.length > 0 ) {
                gemstoneData = data;
            }
        } catch ( error ) {
            console.log( error );
        }

        return gemstoneData;
    }

    async function getGemstoneVariantLinks() {
        let gemstoneLinks = [];

        try {
            const url = `${config.app.API_URL}/api/${config.app.REACT_APP_API_VERSION}/links/gemstones/variants`;
            const requestSettings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            const response = await fetch( url , requestSettings );
            const data = await response.json();

            if ( data?.links?.length > 0 ) {
                gemstoneLinks = data.links;
            }
        } catch ( error ) {
            console.log( error );
        }

        return gemstoneLinks;
    }

    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group">
                        <button className="action-btn" onClick={() => openModal()}>
                            <span className="icon">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5 0.53125C7.5 0.239062 7.25893 0 6.96429 0C6.66964 0 6.42857 0.239062 6.42857 0.53125V6.375H0.535714C0.241071 6.375 0 6.61406 0 6.90625C0 7.19844 0.241071 7.4375 0.535714 7.4375H6.42857V13.2812C6.42857 13.5734 6.66964 13.8125 6.96429 13.8125C7.25893 13.8125 7.5 13.5734 7.5 13.2812V7.4375H13.3929C13.6875 7.4375 13.9286 7.19844 13.9286 6.90625C13.9286 6.61406 13.6875 6.375 13.3929 6.375H7.5V0.53125Z" fill="white"/>
                                </svg>
                            </span>
                            <span className="title">Add New Gemstone</span>
                        </button>

                        <button className='action-btn' onClick={() => openLinkerModal()}>
                            <span className="icon">
                                <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                                    <path d="M0 256C0 167.6 71.6 96 160 96l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C98.1 144 48 194.1 48 256s50.1 112 112 112l72 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c61.9 0 112-50.1 112-112s-50.1-112-112-112l-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c88.4 0 160 71.6 160 160zM184 232l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z" fill="white"/>
                                </svg>
                            </span>
                            <span className="title">Gemstone Product Links</span>
                        </button>
                    </div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>
            <div className="dashboard-body">
                <h1 className="dashboard-title">Gemstones</h1>
                <GemstonesTable
                    gemstones={ gemstones } 
                    gemstoneVariantLinks={ gemstoneVariantLinks }
                    loading={ loadingTable } 
                    pagination={{
                        currentPage: currentPage,
                        totalPages: totalPages
                    }}
                    goToPreviousPage={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    goToNextPage={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    onUpdate={() => setReloadTable( reloadTable + 1 ) }
                />
            </div>
                
            {showModal && (
                <GemstoneEditorModal
                    isOpen={showModal}
                    onClose={() => { 
                        setShowModal(false)
                    }}
                    onAdd={() => {
                        setReloadTable( reloadTable + 1 );
                    }}
                    initialData={gemstoneToEdit}
                />
            )}

            { showProductLinksModal && (
                <GemstoneLinkerModal
                    onClose={() => { 
                        setShowProductLinksModal( false )
                    }}
                    onUpdate={() => {
                        setReloadTable( reloadTable + 1 );
                    }}
                />
            )}
        </div>
    );
}

export default Gemstones;